import { Add } from "@mui/icons-material";
import { Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";

const FileUpload = ({ enableDragAndDrop, loading, handleFiles }) => {
  const MAX_FILE_SIZE = 30 * 1024 * 1024;
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const dropZoneRef = useRef(null);

  useEffect(() => {
    const handlePaste = (event) => {
      const items = event.clipboardData.items;
      const pastedFiles = [];
      
      for (let item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) {
            pastedFiles.push(file);
          }
        }
      }

      if (pastedFiles.length > 0) {
        processFiles(pastedFiles);
      }
    };

    document.addEventListener("paste", handlePaste);
    return () => document.removeEventListener("paste", handlePaste);
  }, []);

  const processFiles = (files) => {
    setError(null);
    const validFiles = files.filter((file) => {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "text/csv",
        "text/plain",
        "application/pdf",
        "video/mp4",
        "video/webm",
        "video/quicktime"
      ];
      return allowedTypes.includes(file.type) && file.size <= MAX_FILE_SIZE;
    });

    if (validFiles.length < files.length) {
      setError(`Only .jpg, .png, .csv, .txt, .pdf, and video (.mp4, .webm, .mov) files under ${MAX_FILE_SIZE / 1024 / 1024}MB are allowed.`);
      return;
    }

    handleFiles(validFiles);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    processFiles(Array.from(e.dataTransfer.files));
  };

  const handleFileChange = (e) => {
    processFiles(Array.from(e.target.files));
  };

  const handleChooseFiles = () => {
    fileInputRef.current.click();
  };

  return loading ? (
    <p style={{ textAlign: "center", padding: "1rem" }}>Uploading...</p>
  ) : (
    <div>
      {enableDragAndDrop ? (
        <div
          ref={dropZoneRef}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleChooseFiles}
          style={{
            border: isDragging ? "2px dashed #007bff" : "2px dashed #cccccc",
            padding: "20px",
            textAlign: "center",
            marginBottom: "20px",
            cursor: "pointer",
            backgroundColor: isDragging ? "#f8f9fa" : "transparent",
          }}
        >
          <p className="text-muted">Drag & drop, click, or paste to upload files</p>
        </div>
      ) : (
        <Button size="sm" variant="" className="me-2" onClick={handleChooseFiles}>
          <Add /> Attach files
        </Button>
      )}
      <input
        type="file"
        multiple
        accept="image/*, .csv, .txt, .pdf, video/mp4, video/webm, video/quicktime"
        onChange={handleFileChange}
        style={{ display: "none" }}
        ref={fileInputRef}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default FileUpload;
